import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const XIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 9, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.853106 8.99512C0.632465 9.0081 0.415472 8.93389 0.247885 8.78814C-0.0826284 8.45178 -0.0826284 7.90851 0.247885 7.57215L7.48505 0.250291C7.82881 -0.0751426 8.36823 -0.0570519 8.68991 0.290733C8.98078 0.605233 8.99774 1.08863 8.7296 1.42318L1.44979 8.78814C1.28437 8.93179 1.07086 9.00586 0.853106 8.99512Z"
        fill="currentColor"
      />
      <path
        d="M8.08185 8.99534C7.85823 8.99438 7.64391 8.90458 7.48513 8.74525L0.247941 1.42337C-0.0582627 1.06162 -0.0166327 0.51719 0.340942 0.207376C0.660086 -0.0691253 1.13076 -0.0691253 1.44988 0.207376L8.72968 7.52923C9.07336 7.85475 9.09113 8.40051 8.76937 8.74821C8.75657 8.76204 8.74335 8.77541 8.72968 8.78837C8.55143 8.94519 8.31683 9.02014 8.08185 8.99534Z"
        fill="currentColor"
      />
    </svg>
  )
})

XIcon.displayName = 'XIcon'
